import { takeLatest, call, put, select } from 'redux-saga/effects';
import _get from 'lodash/get';
import {
    getIrisReturnsContent,
    getIrisContent,
    getCMContent,
} from 'yoda-interfaces/lib/Pdp/ProductContentApi';
import { selectFeatureFlags } from 'yoda-site-components/lib/selectors/ContextSelector';

import {
    PRODUCT_CONTENT_GET_SUCCESS,
    PRODUCT_CONTENT_GET_ERROR,
    IRIS_RETURNS_CONTENT_REQUEST,
    IRIS_CONTENT_GET_REQUEST,
} from '../actionTypes/ProductContentActionTypes';

function* IrisReturnsContentSaga() {
    try {
        const productContent = yield call(getIrisReturnsContent);
        yield put({ type: PRODUCT_CONTENT_GET_SUCCESS, productContent });
    } catch (error) {
        yield put({ type: PRODUCT_CONTENT_GET_ERROR, error });
    }
}

function* IrisContentSaga({ payload }) {
    try {
        const { enableCMFragments = true, enableCmFallBack = true } = yield select(
            selectFeatureFlags
        );

        let rawProductContent = enableCMFragments
            ? yield call(getCMContent, { tagId: payload })
            : yield call(getIrisContent, { tagId: payload });

        let { html = '', title = '' } = enableCMFragments
            ? _get(rawProductContent, 'data.page.grid.placements[0].items[0]', {})
            : _get(rawProductContent, 'data.content.components[0].content', {});

        const productContent = {
            body: html,
            title,
        };

        if (enableCMFragments && enableCmFallBack) {
            if (rawProductContent?.status !== 200 || productContent?.body === '') {
                rawProductContent = yield call(getIrisContent, { tagId: payload });
                ({ html = '', title = '' } = _get(
                    rawProductContent,
                    'data.content.components[0].content',
                    ''
                ));
                productContent.body = html;
                productContent.title = title;
            }
        }

        yield put({ type: PRODUCT_CONTENT_GET_SUCCESS, productContent });
    } catch (error) {
        yield put({ type: PRODUCT_CONTENT_GET_ERROR, error });
    }
}

const watchProductContentSaga = function* watchProductContentSaga() {
    yield takeLatest(IRIS_RETURNS_CONTENT_REQUEST, IrisReturnsContentSaga);
    yield takeLatest(IRIS_CONTENT_GET_REQUEST, IrisContentSaga);
};

watchProductContentSaga.sagaName = 'productContentSaga';
export default watchProductContentSaga;
